module.exports = __webpack_public_path__ + "img/defaultLogo.db1b8280.png";